import { createEvent, createStore } from 'effector'

export const addCheckInProgressId = createEvent<number>(
  'add check in progress id',
)
export const removeCheckInProgressId = createEvent<number>(
  'remove check in progress id',
)
export const $funnelCheckInProgressIds = createStore<number[]>([])
  .on(addCheckInProgressId, (state, id) => [...state, id])
  .on(removeCheckInProgressId, (state, id) =>
    state.filter((funnelId) => funnelId !== id),
  )
